export const COMPLETE_TAILWIND_CSS = `
    <style>
      *,
      :before,
      :after {
        --tw-border-spacing-x: 0;
        --tw-border-spacing-y: 0;
        --tw-translate-x: 0;
        --tw-translate-y: 0;
        --tw-rotate: 0;
        --tw-skew-x: 0;
        --tw-skew-y: 0;
        --tw-scale-x: 1;
        --tw-scale-y: 1;
        --tw-pan-x: ;
        --tw-pan-y: ;
        --tw-pinch-zoom: ;
        --tw-scroll-snap-strictness: proximity;
        --tw-gradient-from-position: ;
        --tw-gradient-via-position: ;
        --tw-gradient-to-position: ;
        --tw-ordinal: ;
        --tw-slashed-zero: ;
        --tw-numeric-figure: ;
        --tw-numeric-spacing: ;
        --tw-numeric-fraction: ;
        --tw-ring-inset: ;
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-color: #fff;
        --tw-ring-color: rgb(59 130 246 / 0.5);
        --tw-ring-offset-shadow: 0 0 #0000;
        --tw-ring-shadow: 0 0 #0000;
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        --tw-blur: ;
        --tw-brightness: ;
        --tw-contrast: ;
        --tw-grayscale: ;
        --tw-hue-rotate: ;
        --tw-invert: ;
        --tw-saturate: ;
        --tw-sepia: ;
        --tw-drop-shadow: ;
        --tw-backdrop-blur: ;
        --tw-backdrop-brightness: ;
        --tw-backdrop-contrast: ;
        --tw-backdrop-grayscale: ;
        --tw-backdrop-hue-rotate: ;
        --tw-backdrop-invert: ;
        --tw-backdrop-opacity: ;
        --tw-backdrop-saturate: ;
        --tw-backdrop-sepia: ;
        --tw-contain-size: ;
        --tw-contain-layout: ;
        --tw-contain-paint: ;
        --tw-contain-style: ;
      }
      ::backdrop {
        --tw-border-spacing-x: 0;
        --tw-border-spacing-y: 0;
        --tw-translate-x: 0;
        --tw-translate-y: 0;
        --tw-rotate: 0;
        --tw-skew-x: 0;
        --tw-skew-y: 0;
        --tw-scale-x: 1;
        --tw-scale-y: 1;
        --tw-pan-x: ;
        --tw-pan-y: ;
        --tw-pinch-zoom: ;
        --tw-scroll-snap-strictness: proximity;
        --tw-gradient-from-position: ;
        --tw-gradient-via-position: ;
        --tw-gradient-to-position: ;
        --tw-ordinal: ;
        --tw-slashed-zero: ;
        --tw-numeric-figure: ;
        --tw-numeric-spacing: ;
        --tw-numeric-fraction: ;
        --tw-ring-inset: ;
        --tw-ring-offset-width: 0px;
        --tw-ring-offset-color: #fff;
        --tw-ring-color: rgb(59 130 246 / 0.5);
        --tw-ring-offset-shadow: 0 0 #0000;
        --tw-ring-shadow: 0 0 #0000;
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        --tw-blur: ;
        --tw-brightness: ;
        --tw-contrast: ;
        --tw-grayscale: ;
        --tw-hue-rotate: ;
        --tw-invert: ;
        --tw-saturate: ;
        --tw-sepia: ;
        --tw-drop-shadow: ;
        --tw-backdrop-blur: ;
        --tw-backdrop-brightness: ;
        --tw-backdrop-contrast: ;
        --tw-backdrop-grayscale: ;
        --tw-backdrop-hue-rotate: ;
        --tw-backdrop-invert: ;
        --tw-backdrop-opacity: ;
        --tw-backdrop-saturate: ;
        --tw-backdrop-sepia: ;
        --tw-contain-size: ;
        --tw-contain-layout: ;
        --tw-contain-paint: ;
        --tw-contain-style: ;
      }
      *,
      :before,
      :after {
        box-sizing: border-box;
        border-width: 0;
        border-style: solid;
        border-color: #e5e7eb;
      }
      :before,
      :after {
        --tw-content: "";
      }
      html,
      :host {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        -moz-tab-size: 4;
        -o-tab-size: 4;
        tab-size: 4;
        font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
          "Segoe UI Emoji", Segoe UI Symbol, "Noto Color Emoji";
        font-feature-settings: normal;
        font-variation-settings: normal;
        -webkit-tap-highlight-color: transparent;
      }
      body {
        margin: 0;
        line-height: inherit;
      }
      hr {
        height: 0;
        color: inherit;
        border-top-width: 1px;
      }
      abbr:where([title]) {
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-size: inherit;
        font-weight: inherit;
      }
      a {
        color: inherit;
        text-decoration: inherit;
      }
      b,
      strong {
        font-weight: bolder;
      }
      code,
      kbd,
      samp,
      pre {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
          Liberation Mono, Courier New, monospace;
        font-feature-settings: normal;
        font-variation-settings: normal;
        font-size: 1em;
      }
      small {
        font-size: 80%;
      }
      sub,
      sup {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }
      sub {
        bottom: -0.25em;
      }
      sup {
        top: -0.5em;
      }
      table {
        text-indent: 0;
        border-color: inherit;
        border-collapse: collapse;
      }
      button,
      input,
      optgroup,
      select,
      textarea {
        font-family: inherit;
        font-feature-settings: inherit;
        font-variation-settings: inherit;
        font-size: 100%;
        font-weight: inherit;
        line-height: inherit;
        letter-spacing: inherit;
        color: inherit;
        margin: 0;
        padding: 0;
      }
      button,
      select {
        text-transform: none;
      }
      button,
      input:where([type="button"]),
      input:where([type="reset"]),
      input:where([type="submit"]) {
        -webkit-appearance: button;
        background-color: transparent;
        background-image: none;
      }
      :-moz-focusring {
        outline: auto;
      }
      :-moz-ui-invalid {
        box-shadow: none;
      }
      progress {
        vertical-align: baseline;
      }
      ::-webkit-inner-spin-button,
      ::-webkit-outer-spin-button {
        height: auto;
      }
      [type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }
      ::-webkit-search-decoration {
        -webkit-appearance: none;
      }
      ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }
      summary {
        display: list-item;
      }
      blockquote,
      dl,
      dd,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      hr,
      figure,
      p,
      pre {
        margin: 0;
      }
      fieldset {
        margin: 0;
        padding: 0;
      }
      legend {
        padding: 0;
      }
      ol,
      ul,
      menu {
        list-style: none;
        margin: 0;
        padding: 0;
      }
      dialog {
        padding: 0;
      }
      textarea {
        resize: vertical;
      }
      input::-moz-placeholder,
      textarea::-moz-placeholder {
        opacity: 1;
        color: #9ca3af;
      }
      input::placeholder,
      textarea::placeholder {
        opacity: 1;
        color: #9ca3af;
      }
      button,
      [role="button"] {
        cursor: pointer;
      }
      :disabled {
        cursor: default;
      }
      img,
      svg,
      video,
      canvas,
      audio,
      iframe,
      embed,
      object {
        display: block;
        vertical-align: middle;
      }
      img,
      video {
        max-width: 100%;
        height: auto;
      }
      [hidden]:where(:not([hidden="until-found"])) {
        display: none;
      }
      :root {
        --background: 0 0% 100%;
        --foreground: 222.2 84% 4.9%;
        --card: 0 0% 100%;
        --card-foreground: 222.2 84% 4.9%;
        --popover: 0 0% 100%;
        --popover-foreground: 222.2 84% 4.9%;
        --primary: 222.2 47.4% 11.2%;
        --primary-foreground: 210 40% 98%;
        --secondary: 210 40% 96.1%;
        --secondary-foreground: 222.2 47.4% 11.2%;
        --muted: 210 40% 96.1%;
        --muted-foreground: 215.4 16.3% 46.9%;
        --accent: 210 40% 96.1%;
        --accent-foreground: 222.2 47.4% 11.2%;
        --destructive: 0 84.2% 60.2%;
        --destructive-foreground: 210 40% 98%;
        --border: 214.3 31.8% 91.4%;
        --input: 214.3 31.8% 91.4%;
        --ring: 222.2 84% 4.9%;
        --radius: 0.5rem;
        --sidebar-background: 0 0% 98%;
        --sidebar-foreground: 240 5.3% 26.1%;
        --sidebar-primary: 240 5.9% 10%;
        --sidebar-primary-foreground: 0 0% 98%;
        --sidebar-accent: 240 4.8% 95.9%;
        --sidebar-accent-foreground: 240 5.9% 10%;
        --sidebar-border: 220 13% 91%;
        --sidebar-ring: 217.2 91.2% 59.8%;
      }
      .dark {
        --background: 222.2 84% 4.9%;
        --foreground: 210 40% 98%;
        --card: 222.2 84% 4.9%;
        --card-foreground: 210 40% 98%;
        --popover: 222.2 84% 4.9%;
        --popover-foreground: 210 40% 98%;
        --primary: 210 40% 98%;
        --primary-foreground: 222.2 47.4% 11.2%;
        --secondary: 217.2 32.6% 17.5%;
        --secondary-foreground: 210 40% 98%;
        --muted: 217.2 32.6% 17.5%;
        --muted-foreground: 215 20.2% 65.1%;
        --accent: 217.2 32.6% 17.5%;
        --accent-foreground: 210 40% 98%;
        --destructive: 0 62.8% 30.6%;
        --destructive-foreground: 210 40% 98%;
        --border: 217.2 32.6% 17.5%;
        --input: 217.2 32.6% 17.5%;
        --ring: 212.7 26.8% 83.9%;
        --sidebar-background: 240 5.9% 10%;
        --sidebar-foreground: 240 4.8% 95.9%;
        --sidebar-primary: 224.3 76.3% 48%;
        --sidebar-primary-foreground: 0 0% 100%;
        --sidebar-accent: 240 3.7% 15.9%;
        --sidebar-accent-foreground: 240 4.8% 95.9%;
        --sidebar-border: 240 3.7% 15.9%;
        --sidebar-ring: 217.2 91.2% 59.8%;
      }
      * {
        border-color: hsl(var(--border));
      }
      html,
      body {
        background-color: hsl(var(--background));
        color: hsl(var(--foreground));
        overflow: hidden;
        height: 100vh;
        width: 100vw;
        margin: 0;
        padding: 0;
      }
      #root {
        height: 100vh;
        width: 100vw;
        overflow: hidden;
        margin: 0;
        padding: 0;
      }
      ::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }
      ::-webkit-scrollbar-track {
        background: #1e293b;
        border-radius: 4px;
      }
      ::-webkit-scrollbar-thumb {
        background: #94a3b8;
        border-radius: 4px;
        -webkit-transition: background-color 0.2s ease;
        transition: background-color 0.2s ease;
      }
      ::-webkit-scrollbar-thumb:hover {
        background: #f8fafc;
      }
      ::-webkit-scrollbar-corner {
        background: #1e293b;
      }
      * {
        scrollbar-width: thin;
        scrollbar-color: hsl(215 20.2% 65.1%) hsl(217.2 32.6% 17.5%);
      }
      .settings-overlay {
        background-color: #1f2937 !important;
        border: none !important;
        outline: none !important;
      }
      .settings-overlay * {
        border-color: transparent !important;
      }
      .craftspace-container {
        overflow: hidden !important;
        max-width: 100vw !important;
        max-height: 100vh !important;
      }
      .panel-container {
        overflow: hidden !important;
        max-height: calc(100vh - 64px) !important;
      }
      html {
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;
      }
      html::-webkit-scrollbar {
        display: none !important;
      }
      body {
        scrollbar-width: none !important;
        -ms-overflow-style: none !important;
      }
      body::-webkit-scrollbar {
        display: none !important;
      }
      .!container {
        width: 100% !important;
        margin-right: auto !important;
        margin-left: auto !important;
        padding-right: 2rem !important;
        padding-left: 2rem !important;
      }
      .container {
        width: 100%;
        margin-right: auto;
        margin-left: auto;
        padding-right: 2rem;
        padding-left: 2rem;
      }
      @media (min-width: 1400px) {
        .!container {
          max-width: 1400px !important;
        }
        .container {
          max-width: 1400px;
        }
      }
      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border-width: 0;
      }
      .pointer-events-none {
        pointer-events: none;
      }
      .pointer-events-auto {
        pointer-events: auto;
      }
      .!visible {
        visibility: visible !important;
      }
      .visible {
        visibility: visible;
      }
      .invisible {
        visibility: hidden;
      }
      .static {
        position: static;
      }
      .fixed {
        position: fixed;
      }
      .absolute {
        position: absolute;
      }
      .relative {
        position: relative;
      }
      .inset-0 {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
      .inset-x-0 {
        left: 0;
        right: 0;
      }
      .inset-y-0 {
        top: 0;
        bottom: 0;
      }
      .-bottom-12 {
        bottom: -3rem;
      }
      .-bottom-2 {
        bottom: -0.5rem;
      }
      .-bottom-3 {
        bottom: -0.75rem;
      }
      .-bottom-4 {
        bottom: -1rem;
      }
      .-left-12 {
        left: -3rem;
      }
      .-left-2 {
        left: -0.5rem;
      }
      .-left-3 {
        left: -0.75rem;
      }
      .-left-4 {
        left: -1rem;
      }
      .-right-12 {
        right: -3rem;
      }
      .-right-2 {
        right: -0.5rem;
      }
      .-right-3 {
        right: -0.75rem;
      }
      .-right-4 {
        right: -1rem;
      }
      .-top-12 {
        top: -3rem;
      }
      .-top-2 {
        top: -0.5rem;
      }
      .-top-3 {
        top: -0.75rem;
      }
      .-top-4 {
        top: -1rem;
      }
      .bottom-0 {
        bottom: 0;
      }
      .bottom-8 {
        bottom: 2rem;
      }
      .left-0 {
        left: 0;
      }
      .left-1 {
        left: 0.25rem;
      }
      .left-1/2 {
        left: 50%;
      }
      .left-2 {
        left: 0.5rem;
      }
      .left-[50%] {
        left: 50%;
      }
      .right-0 {
        right: 0;
      }
      .right-1 {
        right: 0.25rem;
      }
      .right-2 {
        right: 0.5rem;
      }
      .right-3 {
        right: 0.75rem;
      }
      .right-4 {
        right: 1rem;
      }
      .top-0 {
        top: 0;
      }
      .top-1.5 {
        top: 0.375rem;
      }
      .top-1/2 {
        top: 50%;
      }
      .top-16 {
        top: 4rem;
      }
      .top-2 {
        top: 0.5rem;
      }
      .top-3.5 {
        top: 0.875rem;
      }
      .top-4 {
        top: 1rem;
      }
      .top-[1px] {
        top: 1px;
      }
      .top-[50%] {
        top: 50%;
      }
      .top-[60%] {
        top: 60%;
      }
      .top-full {
        top: 100%;
      }
      .z-10 {
        z-index: 10;
      }
      .z-20 {
        z-index: 20;
      }
      .z-30 {
        z-index: 30;
      }
      .z-40 {
        z-index: 40;
      }
      .z-50 {
        z-index: 50;
      }
      .z-[100] {
        z-index: 100;
      }
      .z-[1] {
        z-index: 1;
      }
      .-mx-1 {
        margin-left: -0.25rem;
        margin-right: -0.25rem;
      }
      .mx-2 {
        margin-left: 0.5rem;
        margin-right: 0.5rem;
      }
      .mx-3.5 {
        margin-left: 0.875rem;
        margin-right: 0.875rem;
      }
      .mx-auto {
        margin-left: auto;
        margin-right: auto;
      }
      .my-0.5 {
        margin-top: 0.125rem;
        margin-bottom: 0.125rem;
      }
      .my-1 {
        margin-top: 0.25rem;
        margin-bottom: 0.25rem;
      }
      .-ml-4 {
        margin-left: -1rem;
      }
      .-mt-4 {
        margin-top: -1rem;
      }
      .mb-1 {
        margin-bottom: 0.25rem;
      }
      .mb-2 {
        margin-bottom: 0.5rem;
      }
      .mb-3 {
        margin-bottom: 0.75rem;
      }
      .mb-4 {
        margin-bottom: 1rem;
      }
      .mb-6 {
        margin-bottom: 1.5rem;
      }
      .mb-8 {
        margin-bottom: 2rem;
      }
      .ml-1 {
        margin-left: 0.25rem;
      }
      .ml-12 {
        margin-left: 3rem;
      }
      .ml-2 {
        margin-left: 0.5rem;
      }
      .ml-auto {
        margin-left: auto;
      }
      .mr-1 {
        margin-right: 0.25rem;
      }
      .mr-2 {
        margin-right: 0.5rem;
      }
      .mr-4 {
        margin-right: 1rem;
      }
      .mt-0.5 {
        margin-top: 0.125rem;
      }
      .mt-1 {
        margin-top: 0.25rem;
      }
      .mt-1.5 {
        margin-top: 0.375rem;
      }
      .mt-2 {
        margin-top: 0.5rem;
      }
      .mt-24 {
        margin-top: 6rem;
      }
      .mt-4 {
        margin-top: 1rem;
      }
      .mt-6 {
        margin-top: 1.5rem;
      }
      .mt-auto {
        margin-top: auto;
      }
      .line-clamp-2 {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      .block {
        display: block;
      }
      .inline {
        display: inline;
      }
      .flex {
        display: flex;
      }
      .inline-flex {
        display: inline-flex;
      }
      .table {
        display: table;
      }
      .grid {
        display: grid;
      }
      .contents {
        display: contents;
      }
      .hidden {
        display: none;
      }
      .aspect-square {
        aspect-ratio: 1 / 1;
      }
      .aspect-video {
        aspect-ratio: 16 / 9;
      }
      .size-4 {
        width: 1rem;
        height: 1rem;
      }
      .h-0.5 {
        height: 0.125rem;
      }
      .h-1.5 {
        height: 0.375rem;
      }
      .h-10 {
        height: 2.5rem;
      }
      .h-11 {
        height: 2.75rem;
      }
      .h-12 {
        height: 3rem;
      }
      .h-14 {
        height: 3.5rem;
      }
      .h-16 {
        height: 4rem;
      }
      .h-2 {
        height: 0.5rem;
      }
      .h-2.5 {
        height: 0.625rem;
      }
      .h-20 {
        height: 5rem;
      }
      .h-28 {
        height: 7rem;
      }
      .h-3 {
        height: 0.75rem;
      }
      .h-3.5 {
        height: 0.875rem;
      }
      .h-3/4 {
        height: 75%;
      }
      .h-32 {
        height: 8rem;
      }
      .h-4 {
        height: 1rem;
      }
      .h-5 {
        height: 1.25rem;
      }
      .h-6 {
        height: 1.5rem;
      }
      .h-64 {
        height: 16rem;
      }
      .h-7 {
        height: 1.75rem;
      }
      .h-8 {
        height: 2rem;
      }
      .h-9 {
        height: 2.25rem;
      }
      .h-[1px] {
        height: 1px;
      }
      .h-[calc(100vh-4rem)] {
        height: calc(100vh - 4rem);
      }
      .h-[var(--radix-navigation-menu-viewport-height)] {
        height: var(--radix-navigation-menu-viewport-height);
      }
      .h-[var(--radix-select-trigger-height)] {
        height: var(--radix-select-trigger-height);
      }
      .h-auto {
        height: auto;
      }
      .h-full {
        height: 100%;
      }
      .h-px {
        height: 1px;
      }
      .h-screen {
        height: 100vh;
      }
      .h-svh {
        height: 100svh;
      }
      .max-h-24 {
        max-height: 6rem;
      }
      .max-h-32 {
        max-height: 8rem;
      }
      .max-h-60 {
        max-height: 15rem;
      }
      .max-h-96 {
        max-height: 24rem;
      }
      .max-h-[300px] {
        max-height: 300px;
      }
      .max-h-[600px] {
        max-height: 600px;
      }
      .max-h-[90vh] {
        max-height: 90vh;
      }
      .max-h-screen {
        max-height: 100vh;
      }
      .min-h-0 {
        min-height: 0px;
      }
      .min-h-[400px] {
        min-height: 400px;
      }
      .min-h-[80px] {
        min-height: 80px;
      }
      .min-h-screen {
        min-height: 100vh;
      }
      .min-h-svh {
        min-height: 100svh;
      }
      .w-0 {
        width: 0px;
      }
      .w-1 {
        width: 0.25rem;
      }
      .w-1/2 {
        width: 50%;
      }
      .w-10 {
        width: 2.5rem;
      }
      .w-11 {
        width: 2.75rem;
      }
      .w-12 {
        width: 3rem;
      }
      .w-14 {
        width: 3.5rem;
      }
      .w-16 {
        width: 4rem;
      }
      .w-2 {
        width: 0.5rem;
      }
      .w-2.5 {
        width: 0.625rem;
      }
      .w-20 {
        width: 5rem;
      }
      .w-3 {
        width: 0.75rem;
      }
      .w-3.5 {
        width: 0.875rem;
      }
      .w-3/4 {
        width: 75%;
      }
      .w-32 {
        width: 8rem;
      }
      .w-4 {
        width: 1rem;
      }
      .w-5 {
        width: 1.25rem;
      }
      .w-6 {
        width: 1.5rem;
      }
      .w-64 {
        width: 16rem;
      }
      .w-7 {
        width: 1.75rem;
      }
      .w-72 {
        width: 18rem;
      }
      .w-8 {
        width: 2rem;
      }
      .w-80 {
        width: 20rem;
      }
      .w-9 {
        width: 2.25rem;
      }
      .w-[--sidebar-width] {
        width: var(--sidebar-width);
      }
      .w-[100px] {
        width: 100px;
      }
      .w-[1px] {
        width: 1px;
      }
      .w-auto {
        width: auto;
      }
      .w-full {
        width: 100%;
      }
      .w-max {
        width: -moz-max-content;
        width: max-content;
      }
      .w-px {
        width: 1px;
      }
      .w-screen {
        width: 100vw;
      }
      .min-w-0 {
        min-width: 0px;
      }
      .min-w-5,
      .min-w-[1.25rem] {
        min-width: 1.25rem;
      }
      .min-w-[12rem] {
        min-width: 12rem;
      }
      .min-w-[16rem] {
        min-width: 16rem;
      }
      .min-w-[8rem] {
        min-width: 8rem;
      }
      .min-w-[var(--radix-select-trigger-width)] {
        min-width: var(--radix-select-trigger-width);
      }
      .max-w-2xl {
        max-width: 42rem;
      }
      .max-w-4xl {
        max-width: 56rem;
      }
      .max-w-[--skeleton-width] {
        max-width: var(--skeleton-width);
      }
      .max-w-[20rem] {
        max-width: 20rem;
      }
      .max-w-lg {
        max-width: 32rem;
      }
      .max-w-max {
        max-width: -moz-max-content;
        max-width: max-content;
      }
      .max-w-md {
        max-width: 28rem;
      }
      .max-w-sm {
        max-width: 24rem;
      }
      .flex-1 {
        flex: 1 1 0%;
      }
      .flex-shrink-0,
      .shrink-0 {
        flex-shrink: 0;
      }
      .grow {
        flex-grow: 1;
      }
      .grow-0 {
        flex-grow: 0;
      }
      .basis-full {
        flex-basis: 100%;
      }
      .caption-bottom {
        caption-side: bottom;
      }
      .border-collapse {
        border-collapse: collapse;
      }
      .-translate-x-1/2 {
        --tw-translate-x: -50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .-translate-x-px {
        --tw-translate-x: -1px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .-translate-y-1/2 {
        --tw-translate-y: -50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .translate-x-[-50%] {
        --tw-translate-x: -50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .translate-x-px {
        --tw-translate-x: 1px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .translate-y-[-50%] {
        --tw-translate-y: -50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .rotate-45 {
        --tw-rotate: 45deg;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .rotate-90 {
        --tw-rotate: 90deg;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .transform {
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      @keyframes ping {
        75%,
        to {
          transform: scale(2);
          opacity: 0;
        }
      }
      .animate-ping {
        animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
      }
      @keyframes pulse {
        50% {
          opacity: 0.5;
        }
      }
      .animate-pulse {
        animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
      }
      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
      .animate-spin {
        animation: spin 1s linear infinite;
      }
      .cursor-default {
        cursor: default;
      }
      .cursor-ew-resize {
        cursor: ew-resize;
      }
      .cursor-move {
        cursor: move;
      }
      .cursor-not-allowed {
        cursor: not-allowed;
      }
      .cursor-pointer {
        cursor: pointer;
      }
      .touch-none {
        touch-action: none;
      }
      .select-none {
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
      }
      .resize {
        resize: both;
      }
      .list-none {
        list-style-type: none;
      }
      .grid-flow-col {
        grid-auto-flow: column;
      }
      .grid-cols-1 {
        grid-template-columns: repeat(1, minmax(0, 1fr));
      }
      .grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
      .grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
      }
      .grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr));
      }
      .grid-cols-8 {
        grid-template-columns: repeat(8, minmax(0, 1fr));
      }
      .grid-rows-4 {
        grid-template-rows: repeat(4, minmax(0, 1fr));
      }
      .flex-row {
        flex-direction: row;
      }
      .flex-col {
        flex-direction: column;
      }
      .flex-col-reverse {
        flex-direction: column-reverse;
      }
      .flex-wrap {
        flex-wrap: wrap;
      }
      .items-start {
        align-items: flex-start;
      }
      .items-end {
        align-items: flex-end;
      }
      .items-center {
        align-items: center;
      }
      .items-stretch {
        align-items: stretch;
      }
      .justify-start {
        justify-content: flex-start;
      }
      .justify-end {
        justify-content: flex-end;
      }
      .justify-center {
        justify-content: center;
      }
      .justify-between {
        justify-content: space-between;
      }
      .gap-1 {
        gap: 0.25rem;
      }
      .gap-1.5 {
        gap: 0.375rem;
      }
      .gap-2 {
        gap: 0.5rem;
      }
      .gap-3 {
        gap: 0.75rem;
      }
      .gap-4 {
        gap: 1rem;
      }
      .space-x-1 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(0.25rem * var(--tw-space-x-reverse));
        margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
      }
      .space-x-2 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(0.5rem * var(--tw-space-x-reverse));
        margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
      }
      .space-x-3 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(0.75rem * var(--tw-space-x-reverse));
        margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
      }
      .space-x-4 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-x-reverse: 0;
        margin-right: calc(1rem * var(--tw-space-x-reverse));
        margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
      }
      .space-y-0.5 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
      }
      .space-y-1 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
      }
      .space-y-1.5 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
      }
      .space-y-2 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
      }
      .space-y-3 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
      }
      .space-y-4 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(1rem * var(--tw-space-y-reverse));
      }
      .space-y-6 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
      }
      .space-y-8 > :not([hidden]) ~ :not([hidden]) {
        --tw-space-y-reverse: 0;
        margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
        margin-bottom: calc(2rem * var(--tw-space-y-reverse));
      }
      .overflow-auto {
        overflow: auto;
      }
      .overflow-hidden {
        overflow: hidden;
      }
      .overflow-x-auto {
        overflow-x: auto;
      }
      .overflow-y-auto {
        overflow-y: auto;
      }
      .overflow-x-hidden {
        overflow-x: hidden;
      }
      .truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .whitespace-nowrap {
        white-space: nowrap;
      }
      .break-words {
        overflow-wrap: break-word;
      }
      .rounded {
        border-radius: 0.25rem;
      }
      .rounded-[2px] {
        border-radius: 2px;
      }
      .rounded-[inherit] {
        border-radius: inherit;
      }
      .rounded-full {
        border-radius: 9999px;
      }
      .rounded-lg {
        border-radius: var(--radius);
      }
      .rounded-md {
        border-radius: calc(var(--radius) - 2px);
      }
      .rounded-none {
        border-radius: 0;
      }
      .rounded-sm {
        border-radius: calc(var(--radius) - 4px);
      }
      .rounded-t {
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
      }
      .rounded-t-[10px] {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
      .rounded-tl-sm {
        border-top-left-radius: calc(var(--radius) - 4px);
      }
      .border {
        border-width: 1px;
      }
      .border-2 {
        border-width: 2px;
      }
      .border-4 {
        border-width: 4px;
      }
      .border-[1.5px] {
        border-width: 1.5px;
      }
      .border-y {
        border-top-width: 1px;
        border-bottom-width: 1px;
      }
      .border-b {
        border-bottom-width: 1px;
      }
      .border-b-2 {
        border-bottom-width: 2px;
      }
      .border-l {
        border-left-width: 1px;
      }
      .border-l-2 {
        border-left-width: 2px;
      }
      .border-r {
        border-right-width: 1px;
      }
      .border-t {
        border-top-width: 1px;
      }
      .border-dashed {
        border-style: dashed;
      }
      .border-[--color-border] {
        border-color: var(--color-border);
      }
      .border-blue-200 {
        --tw-border-opacity: 1;
        border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
      }
      .border-blue-300 {
        --tw-border-opacity: 1;
        border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
      }
      .border-blue-400 {
        --tw-border-opacity: 1;
        border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
      }
      .border-blue-500 {
        --tw-border-opacity: 1;
        border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
      }
      .border-blue-500/30 {
        border-color: #3b82f64d;
      }
      .border-blue-500/40 {
        border-color: #3b82f666;
      }
      .border-blue-500/50 {
        border-color: #3b82f680;
      }
      .border-blue-600 {
        --tw-border-opacity: 1;
        border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
      }
      .border-blue-700 {
        --tw-border-opacity: 1;
        border-color: rgb(29 78 216 / var(--tw-border-opacity, 1));
      }
      .border-blue-700/30 {
        border-color: #1d4ed84d;
      }
      .border-blue-700/50 {
        border-color: #1d4ed880;
      }
      .border-border/50 {
        border-color: hsl(var(--border) / 0.5);
      }
      .border-destructive {
        border-color: hsl(var(--destructive));
      }
      .border-destructive/50 {
        border-color: hsl(var(--destructive) / 0.5);
      }
      .border-gray-200 {
        --tw-border-opacity: 1;
        border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
      }
      .border-gray-500 {
        --tw-border-opacity: 1;
        border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
      }
      .border-gray-600 {
        --tw-border-opacity: 1;
        border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
      }
      .border-gray-700 {
        --tw-border-opacity: 1;
        border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
      }
      .border-gray-700/40 {
        border-color: #37415166;
      }
      .border-gray-700/60 {
        border-color: #37415199;
      }
      .border-gray-900 {
        --tw-border-opacity: 1;
        border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
      }
      .border-green-500/40 {
        border-color: #22c55e66;
      }
      .border-green-600 {
        --tw-border-opacity: 1;
        border-color: rgb(22 163 74 / var(--tw-border-opacity, 1));
      }
      .border-green-700 {
        --tw-border-opacity: 1;
        border-color: rgb(21 128 61 / var(--tw-border-opacity, 1));
      }
      .border-input {
        border-color: hsl(var(--input));
      }
      .border-orange-600 {
        --tw-border-opacity: 1;
        border-color: rgb(234 88 12 / var(--tw-border-opacity, 1));
      }
      .border-primary {
        border-color: hsl(var(--primary));
      }
      .border-purple-600 {
        --tw-border-opacity: 1;
        border-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
      }
      .border-red-500 {
        --tw-border-opacity: 1;
        border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
      }
      .border-red-600 {
        --tw-border-opacity: 1;
        border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
      }
      .border-sidebar-border {
        border-color: hsl(var(--sidebar-border));
      }
      .border-transparent {
        border-color: transparent;
      }
      .border-white {
        --tw-border-opacity: 1;
        border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
      }
      .border-white/10 {
        border-color: #ffffff1a;
      }
      .border-white/20 {
        border-color: #fff3;
      }
      .border-yellow-500/30 {
        border-color: #eab3084d;
      }
      .border-yellow-600 {
        --tw-border-opacity: 1;
        border-color: rgb(202 138 4 / var(--tw-border-opacity, 1));
      }
      .border-yellow-600/30 {
        border-color: #ca8a044d;
      }
      .border-l-transparent {
        border-left-color: transparent;
      }
      .border-t-blue-400 {
        --tw-border-opacity: 1;
        border-top-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
      }
      .border-t-blue-500 {
        --tw-border-opacity: 1;
        border-top-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
      }
      .border-t-transparent {
        border-top-color: transparent;
      }
      .bg-[#15191f] {
        --tw-bg-opacity: 1;
        background-color: rgb(21 25 31 / var(--tw-bg-opacity, 1));
      }
      .bg-[#1e2228] {
        --tw-bg-opacity: 1;
        background-color: rgb(30 34 40 / var(--tw-bg-opacity, 1));
      }
      .bg-[--color-bg] {
        background-color: var(--color-bg);
      }
      .bg-accent {
        background-color: hsl(var(--accent));
      }
      .bg-amber-400 {
        --tw-bg-opacity: 1;
        background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
      }
      .bg-background {
        background-color: hsl(var(--background));
      }
      .bg-black {
        --tw-bg-opacity: 1;
        background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
      }
      .bg-black/20 {
        background-color: #0003;
      }
      .bg-black/80 {
        background-color: #000c;
      }
      .bg-black/90 {
        background-color: #000000e6;
      }
      .bg-blue-400 {
        --tw-bg-opacity: 1;
        background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
      }
      .bg-blue-400/10 {
        background-color: #60a5fa1a;
      }
      .bg-blue-50 {
        --tw-bg-opacity: 1;
        background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
      }
      .bg-blue-500 {
        --tw-bg-opacity: 1;
        background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
      }
      .bg-blue-500/10 {
        background-color: #3b82f61a;
      }
      .bg-blue-500/20 {
        background-color: #3b82f633;
      }
      .bg-blue-600 {
        --tw-bg-opacity: 1;
        background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
      }
      .bg-blue-600/20 {
        background-color: #2563eb33;
      }
      .bg-blue-900/20 {
        background-color: #1e3a8a33;
      }
      .bg-blue-900/50 {
        background-color: #1e3a8a80;
      }
      .bg-border {
        background-color: hsl(var(--border));
      }
      .bg-card {
        background-color: hsl(var(--card));
      }
      .bg-destructive {
        background-color: hsl(var(--destructive));
      }
      .bg-foreground {
        background-color: hsl(var(--foreground));
      }
      .bg-gray-100 {
        --tw-bg-opacity: 1;
        background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
      }
      .bg-gray-50 {
        --tw-bg-opacity: 1;
        background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
      }
      .bg-gray-600 {
        --tw-bg-opacity: 1;
        background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
      }
      .bg-gray-700 {
        --tw-bg-opacity: 1;
        background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
      }
      .bg-gray-700/50 {
        background-color: #37415180;
      }
      .bg-gray-800 {
        --tw-bg-opacity: 1;
        background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
      }
      .bg-gray-900 {
        --tw-bg-opacity: 1;
        background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
      }
      .bg-gray-900/20 {
        background-color: #11182733;
      }
      .bg-gray-900/50 {
        background-color: #11182780;
      }
      .bg-green-500 {
        --tw-bg-opacity: 1;
        background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
      }
      .bg-green-500/20 {
        background-color: #22c55e33;
      }
      .bg-green-600 {
        --tw-bg-opacity: 1;
        background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
      }
      .bg-green-900/20 {
        background-color: #14532d33;
      }
      .bg-muted {
        background-color: hsl(var(--muted));
      }
      .bg-muted/50 {
        background-color: hsl(var(--muted) / 0.5);
      }
      .bg-popover {
        background-color: hsl(var(--popover));
      }
      .bg-primary {
        background-color: hsl(var(--primary));
      }
      .bg-purple-600 {
        --tw-bg-opacity: 1;
        background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
      }
      .bg-red-600 {
        --tw-bg-opacity: 1;
        background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
      }
      .bg-secondary {
        background-color: hsl(var(--secondary));
      }
      .bg-sidebar {
        background-color: hsl(var(--sidebar-background));
      }
      .bg-sidebar-border {
        background-color: hsl(var(--sidebar-border));
      }
      .bg-transparent {
        background-color: transparent;
      }
      .bg-white {
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
      }
      .bg-white/10 {
        background-color: #ffffff1a;
      }
      .bg-white/20 {
        background-color: #fff3;
      }
      .bg-white/5 {
        background-color: #ffffff0d;
      }
      .bg-yellow-600 {
        --tw-bg-opacity: 1;
        background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
      }
      .bg-yellow-900/20 {
        background-color: #713f1233;
      }
      .bg-opacity-50 {
        --tw-bg-opacity: 0.5;
      }
      .bg-gradient-to-br {
        background-image: linear-gradient(
          to bottom right,
          var(--tw-gradient-stops)
        );
      }
      .from-gray-900 {
        --tw-gradient-from: #111827 var(--tw-gradient-from-position);
        --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
        --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
      }
      .via-blue-900 {
        --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
        --tw-gradient-stops: var(--tw-gradient-from),
          #1e3a8a var(--tw-gradient-via-position), var(--tw-gradient-to);
      }
      .to-purple-900 {
        --tw-gradient-to: #581c87 var(--tw-gradient-to-position);
      }
      .fill-current {
        fill: currentColor;
      }
      .object-cover {
        -o-object-fit: cover;
        object-fit: cover;
      }
      .p-0 {
        padding: 0;
      }
      .p-1 {
        padding: 0.25rem;
      }
      .p-2 {
        padding: 0.5rem;
      }
      .p-3 {
        padding: 0.75rem;
      }
      .p-4 {
        padding: 1rem;
      }
      .p-6 {
        padding: 1.5rem;
      }
      .p-[1px] {
        padding: 1px;
      }
      .px-1 {
        padding-left: 0.25rem;
        padding-right: 0.25rem;
      }
      .px-2 {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
      .px-2.5 {
        padding-left: 0.625rem;
        padding-right: 0.625rem;
      }
      .px-3 {
        padding-left: 0.75rem;
        padding-right: 0.75rem;
      }
      .px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
      }
      .px-5 {
        padding-left: 1.25rem;
        padding-right: 1.25rem;
      }
      .px-6 {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
      }
      .px-8 {
        padding-left: 2rem;
        padding-right: 2rem;
      }
      .py-0.5 {
        padding-top: 0.125rem;
        padding-bottom: 0.125rem;
      }
      .py-1 {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
      }
      .py-1.5 {
        padding-top: 0.375rem;
        padding-bottom: 0.375rem;
      }
      .py-12 {
        padding-top: 3rem;
        padding-bottom: 3rem;
      }
      .py-2 {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
      }
      .py-3 {
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
      }
      .py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem;
      }
      .py-6 {
        padding-top: 1.5rem;
        padding-bottom: 1.5rem;
      }
      .py-8 {
        padding-top: 2rem;
        padding-bottom: 2rem;
      }
      .pb-3 {
        padding-bottom: 0.75rem;
      }
      .pb-4 {
        padding-bottom: 1rem;
      }
      .pl-2.5 {
        padding-left: 0.625rem;
      }
      .pl-4 {
        padding-left: 1rem;
      }
      .pl-8 {
        padding-left: 2rem;
      }
      .pr-10 {
        padding-right: 2.5rem;
      }
      .pr-2 {
        padding-right: 0.5rem;
      }
      .pr-2.5 {
        padding-right: 0.625rem;
      }
      .pr-8 {
        padding-right: 2rem;
      }
      .pt-0 {
        padding-top: 0;
      }
      .pt-1 {
        padding-top: 0.25rem;
      }
      .pt-2 {
        padding-top: 0.5rem;
      }
      .pt-3 {
        padding-top: 0.75rem;
      }
      .pt-4 {
        padding-top: 1rem;
      }
      .pt-8 {
        padding-top: 2rem;
      }
      .text-left {
        text-align: left;
      }
      .text-center {
        text-align: center;
      }
      .align-middle {
        vertical-align: middle;
      }
      .font-mono {
        font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
          Liberation Mono, Courier New, monospace;
      }
      .text-2xl {
        font-size: 1.5rem;
        line-height: 2rem;
      }
      .text-3xl {
        font-size: 1.875rem;
        line-height: 2.25rem;
      }
      .text-4xl {
        font-size: 2.25rem;
        line-height: 2.5rem;
      }
      .text-[0.8rem] {
        font-size: 0.8rem;
      }
      .text-[11px] {
        font-size: 11px;
      }
      .text-base {
        font-size: 1rem;
        line-height: 1.5rem;
      }
      .text-lg {
        font-size: 1.125rem;
        line-height: 1.75rem;
      }
      .text-sm {
        font-size: 0.875rem;
        line-height: 1.25rem;
      }
      .text-xl {
        font-size: 1.25rem;
        line-height: 1.75rem;
      }
      .text-xs {
        font-size: 0.75rem;
        line-height: 1rem;
      }
      .font-bold {
        font-weight: 700;
      }
      .font-medium {
        font-weight: 500;
      }
      .font-normal {
        font-weight: 400;
      }
      .font-semibold {
        font-weight: 600;
      }
      .lowercase {
        text-transform: lowercase;
      }
      .italic {
        font-style: italic;
      }
      .tabular-nums {
        --tw-numeric-spacing: tabular-nums;
        font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero)
          var(--tw-numeric-figure) var(--tw-numeric-spacing)
          var(--tw-numeric-fraction);
      }
      .leading-none {
        line-height: 1;
      }
      .tracking-tight {
        letter-spacing: -0.025em;
      }
      .tracking-widest {
        letter-spacing: 0.1em;
      }
      .!text-white {
        --tw-text-opacity: 1 !important;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
      }
      .text-accent-foreground {
        color: hsl(var(--accent-foreground));
      }
      .text-amber-400 {
        --tw-text-opacity: 1;
        color: rgb(251 191 36 / var(--tw-text-opacity, 1));
      }
      .text-blue-100 {
        --tw-text-opacity: 1;
        color: rgb(219 234 254 / var(--tw-text-opacity, 1));
      }
      .text-blue-200 {
        --tw-text-opacity: 1;
        color: rgb(191 219 254 / var(--tw-text-opacity, 1));
      }
      .text-blue-300 {
        --tw-text-opacity: 1;
        color: rgb(147 197 253 / var(--tw-text-opacity, 1));
      }
      .text-blue-400 {
        --tw-text-opacity: 1;
        color: rgb(96 165 250 / var(--tw-text-opacity, 1));
      }
      .text-blue-500 {
        --tw-text-opacity: 1;
        color: rgb(59 130 246 / var(--tw-text-opacity, 1));
      }
      .text-blue-600 {
        --tw-text-opacity: 1;
        color: rgb(37 99 235 / var(--tw-text-opacity, 1));
      }
      .text-card-foreground {
        color: hsl(var(--card-foreground));
      }
      .text-current {
        color: currentColor;
      }
      .text-destructive {
        color: hsl(var(--destructive));
      }
      .text-destructive-foreground {
        color: hsl(var(--destructive-foreground));
      }
      .text-foreground {
        color: hsl(var(--foreground));
      }
      .text-foreground/50 {
        color: hsl(var(--foreground) / 0.5);
      }
      .text-gray-300 {
        --tw-text-opacity: 1;
        color: rgb(209 213 219 / var(--tw-text-opacity, 1));
      }
      .text-gray-400 {
        --tw-text-opacity: 1;
        color: rgb(156 163 175 / var(--tw-text-opacity, 1));
      }
      .text-gray-500 {
        --tw-text-opacity: 1;
        color: rgb(107 114 128 / var(--tw-text-opacity, 1));
      }
      .text-gray-600 {
        --tw-text-opacity: 1;
        color: rgb(75 85 99 / var(--tw-text-opacity, 1));
      }
      .text-gray-700 {
        --tw-text-opacity: 1;
        color: rgb(55 65 81 / var(--tw-text-opacity, 1));
      }
      .text-green-300 {
        --tw-text-opacity: 1;
        color: rgb(134 239 172 / var(--tw-text-opacity, 1));
      }
      .text-green-400 {
        --tw-text-opacity: 1;
        color: rgb(74 222 128 / var(--tw-text-opacity, 1));
      }
      .text-muted-foreground {
        color: hsl(var(--muted-foreground));
      }
      .text-orange-400 {
        --tw-text-opacity: 1;
        color: rgb(251 146 60 / var(--tw-text-opacity, 1));
      }
      .text-popover-foreground {
        color: hsl(var(--popover-foreground));
      }
      .text-primary {
        color: hsl(var(--primary));
      }
      .text-primary-foreground {
        color: hsl(var(--primary-foreground));
      }
      .text-purple-400 {
        --tw-text-opacity: 1;
        color: rgb(192 132 252 / var(--tw-text-opacity, 1));
      }
      .text-red-300 {
        --tw-text-opacity: 1;
        color: rgb(252 165 165 / var(--tw-text-opacity, 1));
      }
      .text-red-400 {
        --tw-text-opacity: 1;
        color: rgb(248 113 113 / var(--tw-text-opacity, 1));
      }
      .text-secondary-foreground {
        color: hsl(var(--secondary-foreground));
      }
      .text-sidebar-foreground {
        color: hsl(var(--sidebar-foreground));
      }
      .text-sidebar-foreground/70 {
        color: hsl(var(--sidebar-foreground) / 0.7);
      }
      .text-white {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1));
      }
      .text-white/40 {
        color: #fff6;
      }
      .text-white/60 {
        color: #fff9;
      }
      .text-yellow-100 {
        --tw-text-opacity: 1;
        color: rgb(254 249 195 / var(--tw-text-opacity, 1));
      }
      .text-yellow-200 {
        --tw-text-opacity: 1;
        color: rgb(254 240 138 / var(--tw-text-opacity, 1));
      }
      .text-yellow-300 {
        --tw-text-opacity: 1;
        color: rgb(253 224 71 / var(--tw-text-opacity, 1));
      }
      .text-yellow-400 {
        --tw-text-opacity: 1;
        color: rgb(250 204 21 / var(--tw-text-opacity, 1));
      }
      .underline {
        text-decoration-line: underline;
      }
      .underline-offset-4 {
        text-underline-offset: 4px;
      }
      .opacity-0 {
        opacity: 0;
      }
      .opacity-100 {
        opacity: 1;
      }
      .opacity-20 {
        opacity: 0.2;
      }
      .opacity-50 {
        opacity: 0.5;
      }
      .opacity-60 {
        opacity: 0.6;
      }
      .opacity-70 {
        opacity: 0.7;
      }
      .opacity-90 {
        opacity: 0.9;
      }
      .shadow-[0_0_0_1px_hsl(var(--sidebar-border))] {
        --tw-shadow: 0 0 0 1px hsl(var(--sidebar-border));
        --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
          var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      }
      .shadow-lg {
        --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1),
          0 4px 6px -4px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color),
          0 4px 6px -4px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
          var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      }
      .shadow-md {
        --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1),
          0 2px 4px -2px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color),
          0 2px 4px -2px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
          var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      }
      .shadow-none {
        --tw-shadow: 0 0 #0000;
        --tw-shadow-colored: 0 0 #0000;
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
          var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      }
      .shadow-sm {
        --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
          var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      }
      .shadow-xl {
        --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1),
          0 8px 10px -6px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color),
          0 8px 10px -6px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
          var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      }
      .outline-none {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
      .outline {
        outline-style: solid;
      }
      .ring-0 {
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
          var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
          calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
          var(--tw-shadow, 0 0 #0000);
      }
      .ring-2 {
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
          var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
          calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
          var(--tw-shadow, 0 0 #0000);
      }
      .ring-ring {
        --tw-ring-color: hsl(var(--ring));
      }
      .ring-sidebar-ring {
        --tw-ring-color: hsl(var(--sidebar-ring));
      }
      .ring-offset-background {
        --tw-ring-offset-color: hsl(var(--background));
      }
      .blur {
        --tw-blur: blur(8px);
        filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast)
          var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert)
          var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
      }
      .filter {
        filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast)
          var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert)
          var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
      }
      .backdrop-blur-lg {
        --tw-backdrop-blur: blur(16px);
        -webkit-backdrop-filter: var(--tw-backdrop-blur)
          var(--tw-backdrop-brightness) var(--tw-backdrop-contrast)
          var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate)
          var(--tw-backdrop-invert) var(--tw-backdrop-opacity)
          var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
        backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness)
          var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale)
          var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert)
          var(--tw-backdrop-opacity) var(--tw-backdrop-saturate)
          var(--tw-backdrop-sepia);
      }
      .backdrop-blur-sm {
        --tw-backdrop-blur: blur(4px);
        -webkit-backdrop-filter: var(--tw-backdrop-blur)
          var(--tw-backdrop-brightness) var(--tw-backdrop-contrast)
          var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate)
          var(--tw-backdrop-invert) var(--tw-backdrop-opacity)
          var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
        backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness)
          var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale)
          var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert)
          var(--tw-backdrop-opacity) var(--tw-backdrop-saturate)
          var(--tw-backdrop-sepia);
      }
      .transition {
        transition-property: color, background-color, border-color,
          text-decoration-color, fill, stroke, opacity, box-shadow, transform,
          filter, -webkit-backdrop-filter;
        transition-property: color, background-color, border-color,
          text-decoration-color, fill, stroke, opacity, box-shadow, transform,
          filter, backdrop-filter;
        transition-property: color, background-color, border-color,
          text-decoration-color, fill, stroke, opacity, box-shadow, transform,
          filter, backdrop-filter, -webkit-backdrop-filter;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 0.15s;
      }
      .transition-[left,right,width] {
        transition-property: left, right, width;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 0.15s;
      }
      .transition-[margin,opa] {
        transition-property: margin, opa;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 0.15s;
      }
      .transition-[width,height,padding] {
        transition-property: width, height, padding;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 0.15s;
      }
      .transition-[width] {
        transition-property: width;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 0.15s;
      }
      .transition-all {
        transition-property: all;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 0.15s;
      }
      .transition-colors {
        transition-property: color, background-color, border-color,
          text-decoration-color, fill, stroke;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 0.15s;
      }
      .transition-opacity {
        transition-property: opacity;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 0.15s;
      }
      .transition-transform {
        transition-property: transform;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 0.15s;
      }
      .duration-1000 {
        transition-duration: 1s;
      }
      .duration-200 {
        transition-duration: 0.2s;
      }
      .duration-300 {
        transition-duration: 0.3s;
      }
      .ease-in-out {
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      }
      .ease-linear {
        transition-timing-function: linear;
      }
      @keyframes enter {
        0% {
          opacity: var(--tw-enter-opacity, 1);
          transform: translate3d(
              var(--tw-enter-translate-x, 0),
              var(--tw-enter-translate-y, 0),
              0
            )
            scale3d(
              var(--tw-enter-scale, 1),
              var(--tw-enter-scale, 1),
              var(--tw-enter-scale, 1)
            )
            rotate(var(--tw-enter-rotate, 0));
        }
      }
      @keyframes exit {
        to {
          opacity: var(--tw-exit-opacity, 1);
          transform: translate3d(
              var(--tw-exit-translate-x, 0),
              var(--tw-exit-translate-y, 0),
              0
            )
            scale3d(
              var(--tw-exit-scale, 1),
              var(--tw-exit-scale, 1),
              var(--tw-exit-scale, 1)
            )
            rotate(var(--tw-exit-rotate, 0));
        }
      }
      .animate-in {
        animation-name: enter;
        animation-duration: 0.15s;
        --tw-enter-opacity: initial;
        --tw-enter-scale: initial;
        --tw-enter-rotate: initial;
        --tw-enter-translate-x: initial;
        --tw-enter-translate-y: initial;
      }
      .fade-in-0 {
        --tw-enter-opacity: 0;
      }
      .fade-in-80 {
        --tw-enter-opacity: 0.8;
      }
      .zoom-in-95 {
        --tw-enter-scale: 0.95;
      }
      .duration-1000 {
        animation-duration: 1s;
      }
      .duration-200 {
        animation-duration: 0.2s;
      }
      .duration-300 {
        animation-duration: 0.3s;
      }
      .ease-in-out {
        animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      }
      .ease-linear {
        animation-timing-function: linear;
      }
      .running {
        animation-play-state: running;
      }
      .craftspace-container .panel-container {
        z-index: 20;
      }
      .craftspace-container .viewer-container {
        z-index: 10;
      }
      .craftspace-container .component-container {
        z-index: 5;
      }
      input[type="number"]::-webkit-inner-spin-button,
      input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input[type="number"] {
        -moz-appearance: textfield;
      }
      .file:border-0::file-selector-button {
        border-width: 0px;
      }
      .file:border-gray-500::file-selector-button {
        --tw-border-opacity: 1;
        border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
      }
      .file:bg-gray-600::file-selector-button {
        --tw-bg-opacity: 1;
        background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
      }
      .file:bg-transparent::file-selector-button {
        background-color: transparent;
      }
      .file:text-sm::file-selector-button {
        font-size: 0.875rem;
        line-height: 1.25rem;
      }
      .file:font-medium::file-selector-button {
        font-weight: 500;
      }
      .file:text-foreground::file-selector-button {
        color: hsl(var(--foreground));
      }
      .file:text-white::file-selector-button {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1));
      }
      .placeholder:text-gray-400::-moz-placeholder {
        --tw-text-opacity: 1;
        color: rgb(156 163 175 / var(--tw-text-opacity, 1));
      }
      .placeholder:text-gray-400::placeholder {
        --tw-text-opacity: 1;
        color: rgb(156 163 175 / var(--tw-text-opacity, 1));
      }
      .placeholder:text-muted-foreground::-moz-placeholder {
        color: hsl(var(--muted-foreground));
      }
      .placeholder:text-muted-foreground::placeholder {
        color: hsl(var(--muted-foreground));
      }
      .placeholder:text-white/60::-moz-placeholder {
        color: #fff9;
      }
      .placeholder:text-white/60::placeholder {
        color: #fff9;
      }
      .after:absolute:after {
        content: var(--tw-content);
        position: absolute;
      }
      .after:-inset-2:after {
        content: var(--tw-content);
        top: -0.5rem;
        right: -0.5rem;
        bottom: -0.5rem;
        left: -0.5rem;
      }
      .after:inset-y-0:after {
        content: var(--tw-content);
        top: 0;
        bottom: 0;
      }
      .after:left-1/2:after {
        content: var(--tw-content);
        left: 50%;
      }
      .after:w-1:after {
        content: var(--tw-content);
        width: 0.25rem;
      }
      .after:w-[2px]:after {
        content: var(--tw-content);
        width: 2px;
      }
      .after:-translate-x-1/2:after {
        content: var(--tw-content);
        --tw-translate-x: -50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .first:rounded-l-md:first-child {
        border-top-left-radius: calc(var(--radius) - 2px);
        border-bottom-left-radius: calc(var(--radius) - 2px);
      }
      .first:border-l:first-child {
        border-left-width: 1px;
      }
      .last:rounded-r-md:last-child {
        border-top-right-radius: calc(var(--radius) - 2px);
        border-bottom-right-radius: calc(var(--radius) - 2px);
      }
      .focus-within:relative:focus-within {
        position: relative;
      }
      .focus-within:z-20:focus-within {
        z-index: 20;
      }
      .hover:scale-105:hover {
        --tw-scale-x: 1.05;
        --tw-scale-y: 1.05;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .hover:border-gray-500:hover {
        --tw-border-opacity: 1;
        border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
      }
      .hover:bg-accent:hover {
        background-color: hsl(var(--accent));
      }
      .hover:bg-blue-100:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-blue-500/20:hover {
        background-color: #3b82f633;
      }
      .hover:bg-blue-600:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-blue-600/20:hover {
        background-color: #2563eb33;
      }
      .hover:bg-blue-700:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-destructive/80:hover {
        background-color: hsl(var(--destructive) / 0.8);
      }
      .hover:bg-destructive/90:hover {
        background-color: hsl(var(--destructive) / 0.9);
      }
      .hover:bg-gray-200:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-gray-500:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-gray-600:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-gray-700:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-gray-800:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-green-600:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-green-700:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-muted:hover {
        background-color: hsl(var(--muted));
      }
      .hover:bg-muted/50:hover {
        background-color: hsl(var(--muted) / 0.5);
      }
      .hover:bg-orange-600:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-primary:hover {
        background-color: hsl(var(--primary));
      }
      .hover:bg-primary/80:hover {
        background-color: hsl(var(--primary) / 0.8);
      }
      .hover:bg-primary/90:hover {
        background-color: hsl(var(--primary) / 0.9);
      }
      .hover:bg-purple-600:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-purple-700:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-red-700:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-red-900/20:hover {
        background-color: #7f1d1d33;
      }
      .hover:bg-secondary:hover {
        background-color: hsl(var(--secondary));
      }
      .hover:bg-secondary/80:hover {
        background-color: hsl(var(--secondary) / 0.8);
      }
      .hover:bg-sidebar-accent:hover {
        background-color: hsl(var(--sidebar-accent));
      }
      .hover:bg-white/10:hover {
        background-color: #ffffff1a;
      }
      .hover:bg-white/20:hover {
        background-color: #fff3;
      }
      .hover:bg-yellow-600:hover {
        --tw-bg-opacity: 1;
        background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
      }
      .hover:bg-yellow-600/20:hover {
        background-color: #ca8a0433;
      }
      .hover:text-accent-foreground:hover {
        color: hsl(var(--accent-foreground));
      }
      .hover:text-blue-300:hover {
        --tw-text-opacity: 1;
        color: rgb(147 197 253 / var(--tw-text-opacity, 1));
      }
      .hover:text-blue-400:hover {
        --tw-text-opacity: 1;
        color: rgb(96 165 250 / var(--tw-text-opacity, 1));
      }
      .hover:text-blue-700:hover {
        --tw-text-opacity: 1;
        color: rgb(29 78 216 / var(--tw-text-opacity, 1));
      }
      .hover:text-foreground:hover {
        color: hsl(var(--foreground));
      }
      .hover:text-gray-300:hover {
        --tw-text-opacity: 1;
        color: rgb(209 213 219 / var(--tw-text-opacity, 1));
      }
      .hover:text-muted-foreground:hover {
        color: hsl(var(--muted-foreground));
      }
      .hover:text-primary-foreground:hover {
        color: hsl(var(--primary-foreground));
      }
      .hover:text-red-400:hover {
        --tw-text-opacity: 1;
        color: rgb(248 113 113 / var(--tw-text-opacity, 1));
      }
      .hover:text-sidebar-accent-foreground:hover {
        color: hsl(var(--sidebar-accent-foreground));
      }
      .hover:text-white:hover {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1));
      }
      .hover:underline:hover {
        text-decoration-line: underline;
      }
      .hover:opacity-100:hover {
        opacity: 1;
      }
      .hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]:hover {
        --tw-shadow: 0 0 0 1px hsl(var(--sidebar-accent));
        --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
          var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      }
      .hover:after:bg-sidebar-border:hover:after {
        content: var(--tw-content);
        background-color: hsl(var(--sidebar-border));
      }
      .focus:bg-accent:focus {
        background-color: hsl(var(--accent));
      }
      .focus:bg-gray-700:focus {
        --tw-bg-opacity: 1;
        background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
      }
      .focus:bg-primary:focus {
        background-color: hsl(var(--primary));
      }
      .focus:text-accent-foreground:focus {
        color: hsl(var(--accent-foreground));
      }
      .focus:text-primary-foreground:focus {
        color: hsl(var(--primary-foreground));
      }
      .focus:opacity-100:focus {
        opacity: 1;
      }
      .focus:outline-none:focus {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
      .focus:ring-2:focus {
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
          var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
          calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
          var(--tw-shadow, 0 0 #0000);
      }
      .focus:ring-blue-500:focus {
        --tw-ring-opacity: 1;
        --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
      }
      .focus:ring-ring:focus {
        --tw-ring-color: hsl(var(--ring));
      }
      .focus:ring-offset-2:focus {
        --tw-ring-offset-width: 2px;
      }
      .focus-visible:outline-none:focus-visible {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
      .focus-visible:ring-1:focus-visible {
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
          var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
          calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
          var(--tw-shadow, 0 0 #0000);
      }
      .focus-visible:ring-2:focus-visible {
        --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0
          var(--tw-ring-offset-width) var(--tw-ring-offset-color);
        --tw-ring-shadow: var(--tw-ring-inset) 0 0 0
          calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
        box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
          var(--tw-shadow, 0 0 #0000);
      }
      .focus-visible:ring-ring:focus-visible {
        --tw-ring-color: hsl(var(--ring));
      }
      .focus-visible:ring-sidebar-ring:focus-visible {
        --tw-ring-color: hsl(var(--sidebar-ring));
      }
      .focus-visible:ring-offset-1:focus-visible {
        --tw-ring-offset-width: 1px;
      }
      .focus-visible:ring-offset-2:focus-visible {
        --tw-ring-offset-width: 2px;
      }
      .focus-visible:ring-offset-background:focus-visible {
        --tw-ring-offset-color: hsl(var(--background));
      }
      .active:bg-sidebar-accent:active {
        background-color: hsl(var(--sidebar-accent));
      }
      .active:text-sidebar-accent-foreground:active {
        color: hsl(var(--sidebar-accent-foreground));
      }
      .disabled:pointer-events-none:disabled {
        pointer-events: none;
      }
      .disabled:cursor-not-allowed:disabled {
        cursor: not-allowed;
      }
      .disabled:opacity-50:disabled {
        opacity: 0.5;
      }
      .group/menu-item:focus-within
        .group-focus-within/menu-item:opacity-100 {
        opacity: 1;
      }
      .group:hover .group-hover:scale-105 {
        --tw-scale-x: 1.05;
        --tw-scale-y: 1.05;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .group:hover .group-hover:border-gray-400 {
        --tw-border-opacity: 1;
        border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
      }
      .group/menu-item:hover .group-hover/menu-item:opacity-100,
      .group:hover .group-hover:opacity-100 {
        opacity: 1;
      }
      .group.destructive .group-[.destructive]:border-muted/40 {
        border-color: hsl(var(--muted) / 0.4);
      }
      .group.toaster .group-[.toaster]:border-border {
        border-color: hsl(var(--border));
      }
      .group.toast .group-[.toast]:bg-muted {
        background-color: hsl(var(--muted));
      }
      .group.toast .group-[.toast]:bg-primary {
        background-color: hsl(var(--primary));
      }
      .group.toaster .group-[.toaster]:bg-background {
        background-color: hsl(var(--background));
      }
      .group.destructive .group-[.destructive]:text-red-300 {
        --tw-text-opacity: 1;
        color: rgb(252 165 165 / var(--tw-text-opacity, 1));
      }
      .group.toast .group-[.toast]:text-muted-foreground {
        color: hsl(var(--muted-foreground));
      }
      .group.toast .group-[.toast]:text-primary-foreground {
        color: hsl(var(--primary-foreground));
      }
      .group.toaster .group-[.toaster]:text-foreground {
        color: hsl(var(--foreground));
      }
      .group.alert .group-[.alert]:opacity-100 {
        opacity: 1;
      }
      .group.toaster .group-[.toaster]:shadow-lg {
        --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1),
          0 4px 6px -4px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color),
          0 4px 6px -4px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
          var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      }
      .group.destructive
        .group-[.destructive]:hover:border-destructive/30:hover {
        border-color: hsl(var(--destructive) / 0.3);
      }
      .group.destructive .group-[.destructive]:hover:bg-destructive:hover {
        background-color: hsl(var(--destructive));
      }
      .group.destructive
        .group-[.destructive]:hover:text-destructive-foreground:hover {
        color: hsl(var(--destructive-foreground));
      }
      .group.destructive .group-[.destructive]:hover:text-red-50:hover {
        --tw-text-opacity: 1;
        color: rgb(254 242 242 / var(--tw-text-opacity, 1));
      }
      .group.destructive
        .group-[.destructive]:focus:ring-destructive:focus {
        --tw-ring-color: hsl(var(--destructive));
      }
      .group.destructive .group-[.destructive]:focus:ring-red-400:focus {
        --tw-ring-opacity: 1;
        --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
      }
      .group.destructive
        .group-[.destructive]:focus:ring-offset-red-600:focus {
        --tw-ring-offset-color: #dc2626;
      }
      .peer/menu-button:hover
        ~ .peer-hover/menu-button:text-sidebar-accent-foreground {
        color: hsl(var(--sidebar-accent-foreground));
      }
      .peer:disabled ~ .peer-disabled:cursor-not-allowed {
        cursor: not-allowed;
      }
      .peer:disabled ~ .peer-disabled:opacity-70 {
        opacity: 0.7;
      }
      .has-[[data-variant=inset]]:bg-sidebar:has([data-variant="inset"]) {
        background-color: hsl(var(--sidebar-background));
      }
      .has-[:disabled]:opacity-50:has(:disabled) {
        opacity: 0.5;
      }
      .group/menu-item:has([data-sidebar="menu-action"])
        .group-has-[[data-sidebar=menu-action]]/menu-item:pr-8 {
        padding-right: 2rem;
      }
      .aria-disabled:pointer-events-none[aria-disabled="true"] {
        pointer-events: none;
      }
      .aria-disabled:opacity-50[aria-disabled="true"] {
        opacity: 0.5;
      }
      .aria-selected:bg-accent[aria-selected="true"] {
        background-color: hsl(var(--accent));
      }
      .aria-selected:bg-accent/50[aria-selected="true"] {
        background-color: hsl(var(--accent) / 0.5);
      }
      .aria-selected:text-accent-foreground[aria-selected="true"] {
        color: hsl(var(--accent-foreground));
      }
      .aria-selected:text-muted-foreground[aria-selected="true"] {
        color: hsl(var(--muted-foreground));
      }
      .aria-selected:opacity-100[aria-selected="true"] {
        opacity: 1;
      }
      .aria-selected:opacity-30[aria-selected="true"] {
        opacity: 0.3;
      }
      .data-[disabled=true]:pointer-events-none[data-disabled="true"],
      .data-[disabled]:pointer-events-none[data-disabled] {
        pointer-events: none;
      }
      .data-[panel-group-direction=vertical]:h-px[data-panel-group-direction="vertical"] {
        height: 1px;
      }
      .data-[panel-group-direction=vertical]:w-full[data-panel-group-direction="vertical"] {
        width: 100%;
      }
      .data-[side=bottom]:translate-y-1[data-side="bottom"] {
        --tw-translate-y: 0.25rem;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .data-[side=left]:-translate-x-1[data-side="left"] {
        --tw-translate-x: -0.25rem;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .data-[side=right]:translate-x-1[data-side="right"] {
        --tw-translate-x: 0.25rem;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .data-[side=top]:-translate-y-1[data-side="top"] {
        --tw-translate-y: -0.25rem;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .data-[state=checked]:translate-x-5[data-state="checked"] {
        --tw-translate-x: 1.25rem;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .data-[state=unchecked]:translate-x-0[data-state="unchecked"],
      .data-[swipe=cancel]:translate-x-0[data-swipe="cancel"] {
        --tw-translate-x: 0px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)][data-swipe="end"] {
        --tw-translate-x: var(--radix-toast-swipe-end-x);
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)][data-swipe="move"] {
        --tw-translate-x: var(--radix-toast-swipe-move-x);
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      @keyframes accordion-up {
        0% {
          height: var(--radix-accordion-content-height);
        }
        to {
          height: 0;
        }
      }
      .data-[state=closed]:animate-accordion-up[data-state="closed"] {
        animation: accordion-up 0.2s ease-out;
      }
      @keyframes accordion-down {
        0% {
          height: 0;
        }
        to {
          height: var(--radix-accordion-content-height);
        }
      }
      .data-[state=open]:animate-accordion-down[data-state="open"] {
        animation: accordion-down 0.2s ease-out;
      }
      .data-[panel-group-direction=vertical]:flex-col[data-panel-group-direction="vertical"] {
        flex-direction: column;
      }
      .data-[state=checked]:border-white[data-state="checked"] {
        --tw-border-opacity: 1;
        border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
      }
      .data-[active=true]:bg-sidebar-accent[data-active="true"] {
        background-color: hsl(var(--sidebar-accent));
      }
      .data-[active]:bg-accent/50[data-active] {
        background-color: hsl(var(--accent) / 0.5);
      }
      .data-[selected='true']:bg-accent[data-selected="true"] {
        background-color: hsl(var(--accent));
      }
      .data-[state=active]:bg-background[data-state="active"] {
        background-color: hsl(var(--background));
      }
      .data-[state=active]:bg-gray-600[data-state="active"] {
        --tw-bg-opacity: 1;
        background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
      }
      .data-[state=active]:bg-white/20[data-state="active"] {
        background-color: #fff3;
      }
      .data-[state=checked]:bg-primary[data-state="checked"] {
        background-color: hsl(var(--primary));
      }
      .data-[state=checked]:bg-white[data-state="checked"] {
        --tw-bg-opacity: 1;
        background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
      }
      .data-[state=on]:bg-accent[data-state="on"],
      .data-[state=open]:bg-accent[data-state="open"] {
        background-color: hsl(var(--accent));
      }
      .data-[state=open]:bg-accent/50[data-state="open"] {
        background-color: hsl(var(--accent) / 0.5);
      }
      .data-[state=open]:bg-secondary[data-state="open"] {
        background-color: hsl(var(--secondary));
      }
      .data-[state=selected]:bg-muted[data-state="selected"] {
        background-color: hsl(var(--muted));
      }
      .data-[state=unchecked]:bg-input[data-state="unchecked"] {
        background-color: hsl(var(--input));
      }
      .data-[active=true]:font-medium[data-active="true"] {
        font-weight: 500;
      }
      .data-[active=true]:text-sidebar-accent-foreground[data-active="true"] {
        color: hsl(var(--sidebar-accent-foreground));
      }
      .data-[selected=true]:text-accent-foreground[data-selected="true"] {
        color: hsl(var(--accent-foreground));
      }
      .data-[state=active]:!text-white[data-state="active"] {
        --tw-text-opacity: 1 !important;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
      }
      .data-[state=active]:text-foreground[data-state="active"] {
        color: hsl(var(--foreground));
      }
      .data-[state=active]:text-white[data-state="active"] {
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity, 1));
      }
      .data-[state=checked]:text-gray-900[data-state="checked"] {
        --tw-text-opacity: 1;
        color: rgb(17 24 39 / var(--tw-text-opacity, 1));
      }
      .data-[state=checked]:text-primary-foreground[data-state="checked"] {
        color: hsl(var(--primary-foreground));
      }
      .data-[state=on]:text-accent-foreground[data-state="on"],
      .data-[state=open]:text-accent-foreground[data-state="open"] {
        color: hsl(var(--accent-foreground));
      }
      .data-[state=open]:text-muted-foreground[data-state="open"] {
        color: hsl(var(--muted-foreground));
      }
      .data-[disabled=true]:opacity-50[data-disabled="true"],
      .data-[disabled]:opacity-50[data-disabled] {
        opacity: 0.5;
      }
      .data-[state=open]:opacity-100[data-state="open"] {
        opacity: 1;
      }
      .data-[state=active]:shadow-sm[data-state="active"] {
        --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
        --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
          var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      }
      .data-[swipe=move]:transition-none[data-swipe="move"] {
        transition-property: none;
      }
      .data-[state=closed]:duration-300[data-state="closed"] {
        transition-duration: 0.3s;
      }
      .data-[state=open]:duration-500[data-state="open"] {
        transition-duration: 0.5s;
      }
      .data-[motion\^=from-]:animate-in[data-motion^="from-"],
      .data-[state=open]:animate-in[data-state="open"],
      .data-[state=visible]:animate-in[data-state="visible"] {
        animation-name: enter;
        animation-duration: 0.15s;
        --tw-enter-opacity: initial;
        --tw-enter-scale: initial;
        --tw-enter-rotate: initial;
        --tw-enter-translate-x: initial;
        --tw-enter-translate-y: initial;
      }
      .data-[motion\^=to-]:animate-out[data-motion^="to-"],
      .data-[state=closed]:animate-out[data-state="closed"],
      .data-[state=hidden]:animate-out[data-state="hidden"],
      .data-[swipe=end]:animate-out[data-swipe="end"] {
        animation-name: exit;
        animation-duration: 0.15s;
        --tw-exit-opacity: initial;
        --tw-exit-scale: initial;
        --tw-exit-rotate: initial;
        --tw-exit-translate-x: initial;
        --tw-exit-translate-y: initial;
      }
      .data-[motion\^=from-]:fade-in[data-motion^="from-"] {
        --tw-enter-opacity: 0;
      }
      .data-[motion\^=to-]:fade-out[data-motion^="to-"],
      .data-[state=closed]:fade-out-0[data-state="closed"] {
        --tw-exit-opacity: 0;
      }
      .data-[state=closed]:fade-out-80[data-state="closed"] {
        --tw-exit-opacity: 0.8;
      }
      .data-[state=hidden]:fade-out[data-state="hidden"] {
        --tw-exit-opacity: 0;
      }
      .data-[state=open]:fade-in-0[data-state="open"],
      .data-[state=visible]:fade-in[data-state="visible"] {
        --tw-enter-opacity: 0;
      }
      .data-[state=closed]:zoom-out-95[data-state="closed"] {
        --tw-exit-scale: 0.95;
      }
      .data-[state=open]:zoom-in-90[data-state="open"] {
        --tw-enter-scale: 0.9;
      }
      .data-[state=open]:zoom-in-95[data-state="open"] {
        --tw-enter-scale: 0.95;
      }
      .data-[motion=from-end]:slide-in-from-right-52[data-motion="from-end"] {
        --tw-enter-translate-x: 13rem;
      }
      .data-[motion=from-start]:slide-in-from-left-52[data-motion="from-start"] {
        --tw-enter-translate-x: -13rem;
      }
      .data-[motion=to-end]:slide-out-to-right-52[data-motion="to-end"] {
        --tw-exit-translate-x: 13rem;
      }
      .data-[motion=to-start]:slide-out-to-left-52[data-motion="to-start"] {
        --tw-exit-translate-x: -13rem;
      }
      .data-[side=bottom]:slide-in-from-top-2[data-side="bottom"] {
        --tw-enter-translate-y: -0.5rem;
      }
      .data-[side=left]:slide-in-from-right-2[data-side="left"] {
        --tw-enter-translate-x: 0.5rem;
      }
      .data-[side=right]:slide-in-from-left-2[data-side="right"] {
        --tw-enter-translate-x: -0.5rem;
      }
      .data-[side=top]:slide-in-from-bottom-2[data-side="top"] {
        --tw-enter-translate-y: 0.5rem;
      }
      .data-[state=closed]:slide-out-to-bottom[data-state="closed"] {
        --tw-exit-translate-y: 100%;
      }
      .data-[state=closed]:slide-out-to-left[data-state="closed"] {
        --tw-exit-translate-x: -100%;
      }
      .data-[state=closed]:slide-out-to-left-1/2[data-state="closed"] {
        --tw-exit-translate-x: -50%;
      }
      .data-[state=closed]:slide-out-to-right[data-state="closed"],
      .data-[state=closed]:slide-out-to-right-full[data-state="closed"] {
        --tw-exit-translate-x: 100%;
      }
      .data-[state=closed]:slide-out-to-top[data-state="closed"] {
        --tw-exit-translate-y: -100%;
      }
      .data-[state=closed]:slide-out-to-top-[48%][data-state="closed"] {
        --tw-exit-translate-y: -48%;
      }
      .data-[state=open]:slide-in-from-bottom[data-state="open"] {
        --tw-enter-translate-y: 100%;
      }
      .data-[state=open]:slide-in-from-left[data-state="open"] {
        --tw-enter-translate-x: -100%;
      }
      .data-[state=open]:slide-in-from-left-1/2[data-state="open"] {
        --tw-enter-translate-x: -50%;
      }
      .data-[state=open]:slide-in-from-right[data-state="open"] {
        --tw-enter-translate-x: 100%;
      }
      .data-[state=open]:slide-in-from-top[data-state="open"] {
        --tw-enter-translate-y: -100%;
      }
      .data-[state=open]:slide-in-from-top-[48%][data-state="open"] {
        --tw-enter-translate-y: -48%;
      }
      .data-[state=open]:slide-in-from-top-full[data-state="open"] {
        --tw-enter-translate-y: -100%;
      }
      .data-[state=closed]:duration-300[data-state="closed"] {
        animation-duration: 0.3s;
      }
      .data-[state=open]:duration-500[data-state="open"] {
        animation-duration: 0.5s;
      }
      .data-[panel-group-direction=vertical]:after:left-0[data-panel-group-direction="vertical"]:after {
        content: var(--tw-content);
        left: 0;
      }
      .data-[panel-group-direction=vertical]:after:h-1[data-panel-group-direction="vertical"]:after {
        content: var(--tw-content);
        height: 0.25rem;
      }
      .data-[panel-group-direction=vertical]:after:w-full[data-panel-group-direction="vertical"]:after {
        content: var(--tw-content);
        width: 100%;
      }
      .data-[panel-group-direction=vertical]:after:-translate-y-1/2[data-panel-group-direction="vertical"]:after {
        content: var(--tw-content);
        --tw-translate-y: -50%;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .data-[panel-group-direction=vertical]:after:translate-x-0[data-panel-group-direction="vertical"]:after {
        content: var(--tw-content);
        --tw-translate-x: 0px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .data-[state=open]:hover:bg-sidebar-accent:hover[data-state="open"] {
        background-color: hsl(var(--sidebar-accent));
      }
      .data-[state=open]:hover:text-sidebar-accent-foreground:hover[data-state="open"] {
        color: hsl(var(--sidebar-accent-foreground));
      }
      .group[data-collapsible="offcanvas"]
        .group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)] {
        left: calc(var(--sidebar-width) * -1);
      }
      .group[data-collapsible="offcanvas"]
        .group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)] {
        right: calc(var(--sidebar-width) * -1);
      }
      .group[data-side="left"] .group-data-[side=left]:-right-4 {
        right: -1rem;
      }
      .group[data-side="right"] .group-data-[side=right]:left-0 {
        left: 0;
      }
      .group[data-collapsible="icon"] .group-data-[collapsible=icon]:-mt-8 {
        margin-top: -2rem;
      }
      .group[data-collapsible="icon"]
        .group-data-[collapsible=icon]:hidden {
        display: none;
      }
      .group[data-collapsible="icon"]
        .group-data-[collapsible=icon]:!size-8 {
        width: 2rem !important;
        height: 2rem !important;
      }
      .group[data-collapsible="icon"]
        .group-data-[collapsible=icon]:w-[--sidebar-width-icon] {
        width: var(--sidebar-width-icon);
      }
      .group[data-collapsible="icon"]
        .group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4))] {
        width: calc(var(--sidebar-width-icon) + 1rem);
      }
      .group[data-collapsible="icon"]
        .group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)_+_theme(spacing.4)_+2px)] {
        width: calc(var(--sidebar-width-icon) + 1rem + 2px);
      }
      .group[data-collapsible="offcanvas"]
        .group-data-[collapsible=offcanvas]:w-0 {
        width: 0px;
      }
      .group[data-collapsible="offcanvas"]
        .group-data-[collapsible=offcanvas]:translate-x-0 {
        --tw-translate-x: 0px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .group[data-side="right"] .group-data-[side=right]:rotate-180,
      .group[data-state="open"] .group-data-[state=open]:rotate-180 {
        --tw-rotate: 180deg;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .group[data-collapsible="icon"]
        .group-data-[collapsible=icon]:overflow-hidden {
        overflow: hidden;
      }
      .group[data-variant="floating"]
        .group-data-[variant=floating]:rounded-lg {
        border-radius: var(--radius);
      }
      .group[data-variant="floating"]
        .group-data-[variant=floating]:border {
        border-width: 1px;
      }
      .group[data-side="left"] .group-data-[side=left]:border-r {
        border-right-width: 1px;
      }
      .group[data-side="right"] .group-data-[side=right]:border-l {
        border-left-width: 1px;
      }
      .group[data-variant="floating"]
        .group-data-[variant=floating]:border-sidebar-border {
        border-color: hsl(var(--sidebar-border));
      }
      .group[data-collapsible="icon"] .group-data-[collapsible=icon]:!p-0 {
        padding: 0 !important;
      }
      .group[data-collapsible="icon"] .group-data-[collapsible=icon]:!p-2 {
        padding: 0.5rem !important;
      }
      .group[data-collapsible="icon"]
        .group-data-[collapsible=icon]:opacity-0 {
        opacity: 0;
      }
      .group[data-variant="floating"]
        .group-data-[variant=floating]:shadow {
        --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1),
          0 1px 2px -1px rgb(0 0 0 / 0.1);
        --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color),
          0 1px 2px -1px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
          var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
      }
      .group[data-collapsible="offcanvas"]
        .group-data-[collapsible=offcanvas]:after:left-full:after {
        content: var(--tw-content);
        left: 100%;
      }
      .group[data-collapsible="offcanvas"]
        .group-data-[collapsible=offcanvas]:hover:bg-sidebar:hover {
        background-color: hsl(var(--sidebar-background));
      }
      .peer/menu-button[data-size="default"]
        ~ .peer-data-[size=default]/menu-button:top-1.5 {
        top: 0.375rem;
      }
      .peer/menu-button[data-size="lg"]
        ~ .peer-data-[size=lg]/menu-button:top-2.5 {
        top: 0.625rem;
      }
      .peer/menu-button[data-size="sm"]
        ~ .peer-data-[size=sm]/menu-button:top-1 {
        top: 0.25rem;
      }
      .peer[data-variant="inset"]
        ~ .peer-data-[variant=inset]:min-h-[calc(100svh-theme(spacing.4))] {
        min-height: calc(100svh - 1rem);
      }
      .peer/menu-button[data-active="true"]
        ~ .peer-data-[active=true]/menu-button:text-sidebar-accent-foreground {
        color: hsl(var(--sidebar-accent-foreground));
      }
      .dark:border-destructive:is(.dark *) {
        border-color: hsl(var(--destructive));
      }
      @media (min-width: 640px) {
        .sm:bottom-0 {
          bottom: 0;
        }
        .sm:right-0 {
          right: 0;
        }
        .sm:top-auto {
          top: auto;
        }
        .sm:mt-0 {
          margin-top: 0;
        }
        .sm:flex {
          display: flex;
        }
        .sm:max-w-md {
          max-width: 28rem;
        }
        .sm:max-w-sm {
          max-width: 24rem;
        }
        .sm:flex-row {
          flex-direction: row;
        }
        .sm:flex-col {
          flex-direction: column;
        }
        .sm:justify-end {
          justify-content: flex-end;
        }
        .sm:gap-2.5 {
          gap: 0.625rem;
        }
        .sm:space-x-2 > :not([hidden]) ~ :not([hidden]) {
          --tw-space-x-reverse: 0;
          margin-right: calc(0.5rem * var(--tw-space-x-reverse));
          margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
        }
        .sm:space-x-4 > :not([hidden]) ~ :not([hidden]) {
          --tw-space-x-reverse: 0;
          margin-right: calc(1rem * var(--tw-space-x-reverse));
          margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
        }
        .sm:space-y-0 > :not([hidden]) ~ :not([hidden]) {
          --tw-space-y-reverse: 0;
          margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
          margin-bottom: calc(0px * var(--tw-space-y-reverse));
        }
        .sm:rounded-lg {
          border-radius: var(--radius);
        }
        .sm:text-left {
          text-align: left;
        }
        .data-[state=open]:sm:slide-in-from-bottom-full[data-state="open"] {
          --tw-enter-translate-y: 100%;
        }
      }
      @media (min-width: 768px) {
        .md:absolute {
          position: absolute;
        }
        .md:block {
          display: block;
        }
        .md:flex {
          display: flex;
        }
        .md:w-[var(--radix-navigation-menu-viewport-width)] {
          width: var(--radix-navigation-menu-viewport-width);
        }
        .md:w-auto {
          width: auto;
        }
        .md:max-w-[420px] {
          max-width: 420px;
        }
        .md:grid-cols-2 {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        .md:grid-cols-3 {
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
        .md:text-sm {
          font-size: 0.875rem;
          line-height: 1.25rem;
        }
        .md:opacity-0 {
          opacity: 0;
        }
        .after:md:hidden:after {
          content: var(--tw-content);
          display: none;
        }
        .peer[data-variant="inset"] ~ .md:peer-data-[variant=inset]:m-2 {
          margin: 0.5rem;
        }
        .peer[data-state="collapsed"][data-variant="inset"]
          ~ .md:peer-data-[state=collapsed]:peer-data-[variant=inset]:ml-2 {
          margin-left: 0.5rem;
        }
        .peer[data-variant="inset"] ~ .md:peer-data-[variant=inset]:ml-0 {
          margin-left: 0;
        }
        .peer[data-variant="inset"]
          ~ .md:peer-data-[variant=inset]:rounded-xl {
          border-radius: 0.75rem;
        }
        .peer[data-variant="inset"]
          ~ .md:peer-data-[variant=inset]:shadow {
          --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1),
            0 1px 2px -1px rgb(0 0 0 / 0.1);
          --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color),
            0 1px 2px -1px var(--tw-shadow-color);
          box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000),
            var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
        }
      }
      @media (min-width: 1024px) {
        .lg:grid-cols-3 {
          grid-template-columns: repeat(3, minmax(0, 1fr));
        }
      }
      .[&:has([aria-selected])]:bg-accent:has([aria-selected]) {
        background-color: hsl(var(--accent));
      }
      .first:[&:has([aria-selected])]:rounded-l-md:has(
          [aria-selected]
        ):first-child {
        border-top-left-radius: calc(var(--radius) - 2px);
        border-bottom-left-radius: calc(var(--radius) - 2px);
      }
      .last:[&:has([aria-selected])]:rounded-r-md:has(
          [aria-selected]
        ):last-child {
        border-top-right-radius: calc(var(--radius) - 2px);
        border-bottom-right-radius: calc(var(--radius) - 2px);
      }
      .[&:has([aria-selected].day-outside)]:bg-accent/50:has(
          [aria-selected].day-outside
        ) {
        background-color: hsl(var(--accent) / 0.5);
      }
      .[&:has([aria-selected].day-range-end)]:rounded-r-md:has(
          [aria-selected].day-range-end
        ) {
        border-top-right-radius: calc(var(--radius) - 2px);
        border-bottom-right-radius: calc(var(--radius) - 2px);
      }
      .[&:has([role=checkbox])]:pr-0:has([role="checkbox"]) {
        padding-right: 0;
      }
      .[&>button]:hidden > button {
        display: none;
      }
      .[&>span:last-child]:truncate > span:last-child {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .[&>span]:line-clamp-1 > span {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
      }
      .[&>svg+div]:translate-y-[-3px] > svg + div {
        --tw-translate-y: -3px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .[&>svg]:absolute > svg {
        position: absolute;
      }
      .[&>svg]:left-4 > svg {
        left: 1rem;
      }
      .[&>svg]:top-4 > svg {
        top: 1rem;
      }
      .[&>svg]:size-3.5 > svg {
        width: 0.875rem;
        height: 0.875rem;
      }
      .[&>svg]:size-4 > svg {
        width: 1rem;
        height: 1rem;
      }
      .[&>svg]:h-2.5 > svg {
        height: 0.625rem;
      }
      .[&>svg]:h-3 > svg {
        height: 0.75rem;
      }
      .[&>svg]:w-2.5 > svg {
        width: 0.625rem;
      }
      .[&>svg]:w-3 > svg {
        width: 0.75rem;
      }
      .[&>svg]:shrink-0 > svg {
        flex-shrink: 0;
      }
      .[&>svg]:text-destructive > svg {
        color: hsl(var(--destructive));
      }
      .[&>svg]:text-foreground > svg {
        color: hsl(var(--foreground));
      }
      .[&>svg]:text-muted-foreground > svg {
        color: hsl(var(--muted-foreground));
      }
      .[&>svg]:text-sidebar-accent-foreground > svg {
        color: hsl(var(--sidebar-accent-foreground));
      }
      .[&>svg~*]:pl-7 > svg ~ * {
        padding-left: 1.75rem;
      }
      .[&>tr]:last:border-b-0:last-child > tr {
        border-bottom-width: 0px;
      }
      .[&[data-panel-group-direction=vertical]>div]:rotate-90[data-panel-group-direction="vertical"]
        > div {
        --tw-rotate: 90deg;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .[&[data-state=open]>svg]:rotate-180[data-state="open"] > svg {
        --tw-rotate: 180deg;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y))
          rotate(var(--tw-rotate)) skew(var(--tw-skew-x))
          skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x))
          scaleY(var(--tw-scale-y));
      }
      .[&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground
        .recharts-cartesian-axis-tick
        text {
        fill: hsl(var(--muted-foreground));
      }
      .[&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50
        .recharts-cartesian-grid
        line[stroke="#ccc"] {
        stroke: hsl(var(--border) / 0.5);
      }
      .[&_.recharts-curve.recharts-tooltip-cursor]:stroke-border
        .recharts-curve.recharts-tooltip-cursor {
        stroke: hsl(var(--border));
      }
      .[&_.recharts-dot[stroke='#fff']]:stroke-transparent
        .recharts-dot[stroke="#fff"] {
        stroke: transparent;
      }
      .[&_.recharts-layer]:outline-none .recharts-layer {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
      .[&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border
        .recharts-polar-grid
        [stroke="#ccc"] {
        stroke: hsl(var(--border));
      }
      .[&_.recharts-radial-bar-background-sector]:fill-muted
        .recharts-radial-bar-background-sector,
      .[&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted
        .recharts-rectangle.recharts-tooltip-cursor {
        fill: hsl(var(--muted));
      }
      .[&_.recharts-reference-line_[stroke='#ccc']]:stroke-border
        .recharts-reference-line
        [stroke="#ccc"] {
        stroke: hsl(var(--border));
      }
      .[&_.recharts-sector[stroke='#fff']]:stroke-transparent
        .recharts-sector[stroke="#fff"] {
        stroke: transparent;
      }
      .[&_.recharts-sector]:outline-none .recharts-sector,
      .[&_.recharts-surface]:outline-none .recharts-surface {
        outline: 2px solid transparent;
        outline-offset: 2px;
      }
      .[&_[cmdk-group-heading]]:px-2 [cmdk-group-heading] {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
      .[&_[cmdk-group-heading]]:py-1.5 [cmdk-group-heading] {
        padding-top: 0.375rem;
        padding-bottom: 0.375rem;
      }
      .[&_[cmdk-group-heading]]:text-xs [cmdk-group-heading] {
        font-size: 0.75rem;
        line-height: 1rem;
      }
      .[&_[cmdk-group-heading]]:font-medium [cmdk-group-heading] {
        font-weight: 500;
      }
      .[&_[cmdk-group-heading]]:text-muted-foreground
        [cmdk-group-heading] {
        color: hsl(var(--muted-foreground));
      }
      .[&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0
        [cmdk-group]:not([hidden])
        ~ [cmdk-group] {
        padding-top: 0;
      }
      .[&_[cmdk-group]]:px-2 [cmdk-group] {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
      .[&_[cmdk-input-wrapper]_svg]:h-5 [cmdk-input-wrapper] svg {
        height: 1.25rem;
      }
      .[&_[cmdk-input-wrapper]_svg]:w-5 [cmdk-input-wrapper] svg {
        width: 1.25rem;
      }
      .[&_[cmdk-input]]:h-12 [cmdk-input] {
        height: 3rem;
      }
      .[&_[cmdk-item]]:px-2 [cmdk-item] {
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
      .[&_[cmdk-item]]:py-3 [cmdk-item] {
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
      }
      .[&_[cmdk-item]_svg]:h-5 [cmdk-item] svg {
        height: 1.25rem;
      }
      .[&_[cmdk-item]_svg]:w-5 [cmdk-item] svg {
        width: 1.25rem;
      }
      .[&_p]:leading-relaxed p {
        line-height: 1.625;
      }
      .[&_svg]:pointer-events-none svg {
        pointer-events: none;
      }
      .[&_svg]:size-4 svg {
        width: 1rem;
        height: 1rem;
      }
      .[&_svg]:shrink-0 svg {
        flex-shrink: 0;
      }
      .[&_tr:last-child]:border-0 tr:last-child {
        border-width: 0px;
      }
      .[&_tr]:border-b tr {
        border-bottom-width: 1px;
      }
      [data-side="left"][data-collapsible="offcanvas"]
        .[[data-side=left][data-collapsible=offcanvas]_&]:-right-2 {
        right: -0.5rem;
      }
      [data-side="left"][data-state="collapsed"]
        .[[data-side=left][data-state=collapsed]_&]:cursor-e-resize {
        cursor: e-resize;
      }
      [data-side="left"] .[[data-side=left]_&]:cursor-w-resize {
        cursor: w-resize;
      }
      [data-side="right"][data-collapsible="offcanvas"]
        .[[data-side=right][data-collapsible=offcanvas]_&]:-left-2 {
        left: -0.5rem;
      }
      [data-side="right"][data-state="collapsed"]
        .[[data-side=right][data-state=collapsed]_&]:cursor-w-resize {
        cursor: w-resize;
      }
      [data-side="right"] .[[data-side=right]_&]:cursor-e-resize {
        cursor: e-resize;
      }
    </style>
`;
